import Parseable from '@/misc/Parseable';

/**
 * One referred driver as returned by promoter/:id/statistics. Deleted drivers
 * are included (they always counted toward the statistics) and are flagged so
 * the table can mark them.
 */
export interface PromoterStatisticsDriver {
    firstName: string,
    lastName: string,
    serialId: string | null,
    company: string | null,
    active: boolean,
    isVerified: boolean,
    isDeleted: boolean,
    createdAt: string
}

export default class PromoterStatistics extends Parseable {
    public drivers!: PromoterStatisticsDriver[];
    public companies!: string[];

    public static parseFromObject(object: Partial<PromoterStatistics>): PromoterStatistics {
        const statistics = new PromoterStatistics();
        Object.assign(statistics, object);
        return statistics;
    }

    public parseToObject(): Partial<PromoterStatistics> {
        const tmp = { ...this };
        return tmp;
    }
}
